import React, { Component } from 'react';
import SelectWithSearch from './forms/fields/selectWithSearch_v2'
import { v4 as uuidv4 } from 'uuid';
import { GOOGLE_MAPS_API_KEY } from '../constants';

import { formatCSS } from '../appBuilder/cssHelper';

import { API_ENDPOINT } from '../constants';


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status,

        }
    })
}


export class ConditionalLinksLandingComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            conditionalLinks: [],
        };
    }

    fetchConditionalLinks = () => {
        const groupId = this.props.data?._id;
        const userId = this.props.uData?._id;
        const profile = typeof localStorage !== 'undefined' && localStorage.profile ? localStorage.profile : null;

        const data = {
            groupId: groupId,
            userId: userId,
            profile: profile,
        }
        this.setState({ conditionalLinks: [] }, () => {
            fetch(API_ENDPOINT + '/data/conditional-links/user-data/fetch', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                if (!result.error && result?.length) {
                    this.setState({ conditionalLinks: result })
                }

            })
        })

    }





    componentDidMount() {
        this.fetchConditionalLinks();

        setTimeout(() => {
            this.checkHeightOfRoot();
        }, 600);

    }
    checkHeightOfRoot = () => {
        if (typeof window === 'undefined') return;
        const nodeKey = this.props.node?.key ? this.props.node.key : null;
        if (!nodeKey) return;
        const rootKey = `${nodeKey}-root`;
        const rootElement = document.getElementById(rootKey);

        const innerElement = document.getElementById(nodeKey);

        const rootElementHeight = rootElement?.offsetHeight;
        const innerElementHeight = innerElement?.offsetHeight ?? 0;


        if (!rootElementHeight) return;

        const idealHeight = innerElementHeight ? innerElementHeight + 100 : 0;

        if (Math.abs(rootElementHeight - idealHeight) > 100) {
            rootElement.style.height = idealHeight + 'px';
        }

        const parentKey = this.props.node?.parent ? this.props.node.parent : null;
        let parentElement = document.getElementById(parentKey);
        let parentElementHeight = parentElement?.offsetHeight;
        if (parentElementHeight < idealHeight) {
            parentElement.style.height = idealHeight + 'px';
            parentElement = document.getElementById(parentKey);
            parentElementHeight = parentElement?.offsetHeight;
        }

        const parent = parentElement.parentElement;
        const parentHeight = parent?.offsetHeight;

        if (!parent || !parentElement) return;
        if (Math.abs(parentHeight - parentElementHeight) > 100) {
            parent.style.height = parentElementHeight + 'px';
        }



    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps?.uData?._id !== this.props?.uData?._id) {
            this.fetchConditionalLinks();

            setTimeout(() => {
                this.checkHeightOfRoot();
            }, 600);
        }


    }

    goToLink = (link, buttonText, chapterName, conditionalLinkId) => {
        if (!link) return;
        if (typeof window === 'undefined') return;

        const isGumletVideoLink = link.includes('gumlet.io');
        if (isGumletVideoLink) {
            let linkSplit = link.split('gumlet.io/');
            let paramsSplit = linkSplit[1].split('/');
            const gumletId = paramsSplit?.[1]?.length === 24 ? paramsSplit[1] : null;

            if (gumletId?.length === 24) {
                // window.open(`${window.origin}/gumlet-gateway/${gumletId}`, '_blank')
                this.props[0].history.push({
                    pathname: `/gumlet-gateway`,
                    state: {
                        gumletId: gumletId,
                        title: chapterName,
                        subtitle: buttonText,
                        web: true,
                        conditionalLinkId,
                        returnUrl: this.props[0].location.pathname
                    }
                })
                return;
            }
        }
        window.open(link, '_blank')
    }
    render() {
        const conditionalLinks = this.props.isEnabledConditionalLinks && this.state.conditionalLinks?.length ? this.state.conditionalLinks : null;
        // if (!conditionalLinks) return null;

        const wrapStyle = this.props.wrapStyle ?? {};
        const node = this.props.node;
        const style = this.props.style ?? {};
        const activeStyle = this.props.activeStyle ?? {};
        if (!node) return null;

        const buttonComponent = (buttonText = 'External Link'.translate(this.props.lang), buttonLink, keyVal, chapterName, conditionalLinkId) => {
            let iconStyle = {
                width: 36,
                height: 36,
                objectFit: 'contain'
            };

            if (node.props) {
                if (node.props.iconWidth) {
                    iconStyle.width = node.props.iconWidth + 'px';
                }
                if (node.props.iconHeight) {
                    iconStyle.height = node.props.iconHeight + 'px';
                }
                if (node.props.iconMarginLeft) {
                    iconStyle.marginLeft = node.props.iconMarginLeft + 'px';
                }
                if (node.props.iconMarginTop) {
                    iconStyle.marginTop = node.props.iconMarginTop + 'px';
                }
                if (node.props.iconMarginRight) {
                    iconStyle.marginRight = node.props.iconMarginRight + 'px';
                }
                if (node.props.iconMarginBottom) {
                    iconStyle.marginBottom = node.props.iconMarginBottom + 'px';
                }

            }
            let iconStyleWrap = iconStyle;
            let icon = null
            if (node.props && node.props.icon && node.props.icon != 'null')
                icon = API_ENDPOINT + node.props.icon;


            if (!icon) {
                iconStyleWrap.display = 'none';
            }

            let buttonStyle = { border: 0, outline: 'none', ...style, width: '100%', height: '100%' };
            if (buttonStyle?.marginBottom) {
                delete buttonStyle.marginBottom;
            }

            const buttonWrapStyle = { ...style, maxWidth: '100%' };

            const keyValue = `${node.key}-${keyVal}`;
            return (
                <div
                    style={buttonWrapStyle}
                    onMouseEnter={() => {
                        let elementStyle = JSON.parse(JSON.stringify(activeStyle))
                        Object.keys(elementStyle).map(function (key, index) {
                            if (document.getElementById(keyValue)?.style?.[`${key}`])
                                document.getElementById(keyValue).style[`${key}`] = elementStyle[key];
                        });

                        let iconStyleActive = JSON.parse(JSON.stringify(iconStyleWrap))
                        if (node.activeProps) {
                            if (node.activeProps.iconWidth) {
                                iconStyleActive.width = node.activeProps.iconWidth + 'px';
                            }
                            if (node.activeProps.iconHeight) {
                                iconStyleActive.height = node.activeProps.iconHeight + 'px';
                            }
                            if (node.activeProps.iconMarginLeft) {
                                iconStyleActive.marginLeft = node.activeProps.iconMarginLeft + 'px';
                            }
                            if (node.activeProps.iconMarginTop) {
                                iconStyleActive.marginTop = node.activeProps.iconMarginTop + 'px';
                            }
                            if (node.activeProps.iconMarginRight) {
                                iconStyleActive.marginRight = node.activeProps.iconMarginRight + 'px';
                            }
                            if (node.activeProps.iconMarginBottom) {
                                iconStyleActive.marginBottom = node.activeProps.iconMarginBottom + 'px';
                            }
                            if (node.activeProps.icon && node.activeProps.icon != 'null') {
                                icon = API_ENDPOINT + node.activeProps.icon;
                                if (document.getElementById(keyValue + 'image')) {
                                    document.getElementById(keyValue + 'image').src = icon;
                                    document.getElementById(keyValue + 'image').style.display = 'block';
                                }
                            } else {
                                icon = null;
                                if (document.getElementById(keyValue + 'image')) {
                                    document.getElementById(keyValue + 'image').src = null;
                                    document.getElementById(keyValue + 'image').style.display = 'none';
                                }
                            }
                        }
                        elementStyle = JSON.parse(JSON.stringify(iconStyleActive))
                        Object.keys(elementStyle).map(function (key, index) {
                            if (document.getElementById(keyValue + 'image') && document.getElementById(keyValue + 'image').style) {
                                document.getElementById(keyValue + 'image').style[`${key}`] = elementStyle[key];
                            }
                        });
                        iconStyleWrap = iconStyleActive

                    }}
                    onMouseLeave={() => {
                        let elementStyle = JSON.parse(JSON.stringify(activeStyle))
                        Object.keys(elementStyle).map(function (key, index) {
                            if (document.getElementById(keyValue)?.style?.[`${key}`])
                                document.getElementById(keyValue).style[`${key}`] = 'unset';
                        });
                        elementStyle = JSON.parse(JSON.stringify(buttonStyle))
                        Object.keys(elementStyle).map(function (key, index) {
                            if (document.getElementById(keyValue)?.style?.[`${key}`])
                                document.getElementById(keyValue).style[`${key}`] = elementStyle[key];
                        });


                        let iconStyle = JSON.parse(JSON.stringify(iconStyleWrap))
                        if (node.activeProps) {
                            if (node.activeProps.iconWidth) {
                                iconStyle.width = node.activeProps.iconWidth + 'px';
                            }
                            if (node.activeProps.iconHeight) {
                                iconStyle.height = node.activeProps.iconHeight + 'px';
                            }
                            if (node.activeProps.iconMarginLeft) {
                                iconStyle.marginLeft = node.activeProps.iconMarginLeft + 'px';
                            }
                            if (node.activeProps.iconMarginTop) {
                                iconStyle.marginTop = node.activeProps.iconMarginTop + 'px';
                            }
                            if (node.activeProps.iconMarginRight) {
                                iconStyle.marginRight = node.activeProps.iconMarginRight + 'px';
                            }
                            if (node.activeProps.iconMarginBottom) {
                                iconStyle.marginBottom = node.activeProps.iconMarginBottom + 'px';
                            }
                        }
                        Object.keys(iconStyle).map(function (key, index) {
                            iconStyle[`${key}`] = 'unset';
                        });
                        iconStyle = {
                            width: '36px',
                            height: '36px',
                            objectFit: 'contain'
                        };


                        if (node.props) {
                            if (node.props.iconWidth) {
                                iconStyle.width = node.props.iconWidth + 'px';
                            }
                            if (node.props.iconHeight) {
                                iconStyle.height = node.props.iconHeight + 'px';
                            }
                            if (node.props.iconMarginLeft) {
                                iconStyle.marginLeft = node.props.iconMarginLeft + 'px';
                            }
                            if (node.props.iconMarginTop) {
                                iconStyle.marginTop = node.props.iconMarginTop + 'px';
                            }
                            if (node.props.iconMarginRight) {
                                iconStyle.marginRight = node.props.iconMarginRight + 'px';
                            }
                            if (node.props.iconMarginBottom) {
                                iconStyle.marginBottom = node.props.iconMarginBottom + 'px';
                            }

                            if (node.props.icon && node.props.icon != 'null') {
                                icon = API_ENDPOINT + node.props.icon;
                                if (document.getElementById(keyValue + 'image')) {
                                    document.getElementById(keyValue + 'image').src = icon;
                                    document.getElementById(keyValue + 'image').style.display = 'block';
                                }
                            } else {
                                icon = null;
                                if (document.getElementById(keyValue + 'image')) {
                                    document.getElementById(keyValue + 'image').src = null;
                                    document.getElementById(keyValue + 'image').style.display = 'none';
                                }
                            }

                        }
                        elementStyle = JSON.parse(JSON.stringify(iconStyle))
                        Object.keys(elementStyle).map(function (key, index) {
                            if (document.getElementById(keyValue + 'image')?.style?.[`${key}`])
                                document.getElementById(keyValue + 'image').style[`${key}`] = elementStyle[key];
                        });
                        iconStyleWrap = iconStyle;

                    }}
                >


                    <button
                        className={`node-${node.type}`}
                        style={buttonStyle}
                        id={keyValue}
                        onClick={() => {
                            if (buttonLink)
                                this.goToLink(buttonLink, buttonText, chapterName, conditionalLinkId);
                        }}
                    >
                        <img style={{ ...iconStyleWrap }} id={keyValue + 'image'} src={icon} />
                        <div dangerouslySetInnerHTML={{ __html: buttonText }}></div>
                    </button>
                </div>
            )
        }
        return (

            <div style={wrapStyle} id={`${node.key}-root`}>
                <div
                    className='conditional-links-landing-component-wrap'
                    id={node.key}
                // style={formatCSS(this.props.css)}
                >
                    {
                        conditionalLinks && conditionalLinks.map((item, idx) => {
                            return (
                                <div key={item._id}>
                                    <div style={{ marginBottom: 10, fontSize: 18, fontWeight: 'bold' }}>
                                        {item?.name}
                                    </div>
                                    {
                                        item?.arrayOfAllowedLinks?.map((link, linkIdx) => {
                                            return buttonComponent(link?.buttonText ?? 'External Link'.translate(this.props.lang), link.link, `${idx}-${linkIdx}`, item?.name, item?._id)
                                        })
                                    }
                                </div>
                            )
                        })
                    }


                </div>
            </div>


        )
    }
}

export default ConditionalLinksLandingComponent;